import { extractProps } from '@famly/mf_ts-utils_extract-props';
export const extractDataProps = (props) => {
    return extractProps(props, 'data');
};
